import type { Registry as Services } from '@ember/service';
import type Store from '@ember-data/store';
import { tKey } from 'ember-intl';
import type { Ota } from 'frontend-utils/models';
import type { Platform } from 'frontend-utils/utils/constants/constant-values';
import { PLATFORM_TRANSLATION_KEYS } from 'lumen/utils/constants/general-constants';
import type { Breakdown } from 'lumen/utils/constants/pi-constant-values';
import { PI_BREAKDOWNS } from 'lumen/utils/constants/pi-constant-values';
/**
 * Checks if the segmentationValue is one of the exceptions
 * @param  { string } segmentationValue  : value of the segmentation
 * @param  { object } intl : service used for the translations
 * @param { string } segmentationId : value of the segmentation id
 * @param { object } store               : Ember store pased through
 * @return { string }                    : correct display value
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function segmentationValueFormatter(
  segmentationValue: string,
  intl: Services['intl'],
  segmentationId: Breakdown | null = null,
  store: Store | null = null,
) {
  if (segmentationValue === 'direct') {
    return intl.t(tKey('parity_analytics.directly_shopped'));
  }

  if (segmentationValue === 'contract') {
    return intl.t(tKey('parity_analytics.contract'));
  }

  if (segmentationValue === 'non-contract') {
    return intl.t(tKey('parity_analytics.non-contract'));
  }

  if (segmentationId === PI_BREAKDOWNS.PLATFORM) {
    const platformId = parseInt(segmentationValue, 10) as Platform;
    return intl.t(PLATFORM_TRANSLATION_KEYS[platformId]);
  }

  if (
    (segmentationId === PI_BREAKDOWNS.SOURCE ||
      segmentationId === PI_BREAKDOWNS.CHANNEL) &&
    store !== null
  ) {
    const record = store.peekRecord<Ota>('ota', segmentationValue);
    const otaName = record !== null ? record.name : segmentationValue;
    return otaName;
  }

  if (
    segmentationId === PI_BREAKDOWNS.MARKET_ID &&
    segmentationValue?.indexOf('general.myhotels') === 0
  ) {
    return intl.t(segmentationValue);
  }

  return segmentationValue;
}
